import request from '@/utils/request'

// 摄像头设备列表
export function cameraList(params) {
  return request({
    url: '/biz/alarmInfo/getCameraList',
    method: 'get',
    params
  })
}

//  设备的健康状态
export function deviceStatus(params) {
  return request({
    url: '/biz/alarmInfogetDeviceTotal',
    method: 'get',
    params
  })
}

// 设备类型
export function deviceType(params) {
  return request({
    url: '/biz/alarmInfo/getDeviceType',
    method: 'get',
    params
  })
}

// 更多分页
export function moreList(params) {
  return request({
    url: '/biz/alarmInfo/list',
    method: 'get',
    params
  })
}




